import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CirclePlus, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";
import { IItemHistoricoServico } from "../../../../types";

const detectaServicoCriado = (acao: string): boolean => {
  const acaoLower = acao.toLowerCase().trim();
  return acaoLower === 'criação' || acaoLower.includes('serviço criado');
};

const getIconServicoCriado = (acao: string): { Icon: LucideIcon; color: string } => {
  return { Icon: CirclePlus, color: 'var(--c2e86de)' };
};

export default function CardServicoCriado({ item, isExpanded, onToggleExpand }: CardHistoricoProps) {
  // Este card é específico para serviços, então fazemos type assertion
  const itemServico = item as IItemHistoricoServico;
  
  return (
    <CardHistoricoBase
      item={item}
      icon={getIconServicoCriado(item.acao)}
      temExpansaoDisponivel={true}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      expandedContent={<ExpandedContent item={itemServico} />}
      tituloCustomizado="Serviço criado"
    />
  );
}

export const servicoCriadoConfig = {
  tipo: 'servico_criado',
  detectaTipo: detectaServicoCriado,
  getIcon: getIconServicoCriado,
  temExpansao: () => true,
  Component: CardServicoCriado
};
